<template>
    <div class="flex justify-between">
        <sub-nav />
        <div>
            <p class="text-sm text-gray-700 leading-5">
                Showing
                <span class="font-medium" v-text="meta.from"></span>
                to
                <span class="font-medium" v-text="meta.to"></span>
                of
                <span class="font-medium" v-text="meta.total"></span>
                results
            </p>
        </div>
    </div>
    <div>
        <div class="date-container">
            <span>From: </span>
            <datepicker class="rounded border-gray-300" v-model="fromPicked" :lower-limit="dateLowerLimit" :upper-limit="dateUpperLimit"/>

            <span>To: </span>
            <datepicker class="rounded border-gray-300" v-model="toPicked"  :upper-limit="dateUpperLimit"/>
            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" @click="filterDate">Filter Date</button>
            <button class="ml-auto bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" @click="downloadCsv">Download CSV</button>
        </div>

        <table id="myTable">
            <tr class="header">
                <th id="sn">S/N</th>
                <th id="user">User</th>
                <th id="event">Event</th>
                <th id="event_details">Event Details</th>
                <th id="date">Activity Date</th>
            </tr>
            <tr v-for="item in data" :key='item.id'>
                <td>{{ item.id }}</td>
                <td v-if="item.user && item.user.first_name">{{ item.user.first_name }} {{ item.user.last_name }}</td>
                <td v-else>{{ item.user }}</td>
                <td>{{ item.event }}</td>
                <td>{{ item.event_details }}</td>
                <td>{{ item.date }}</td>
            </tr>

        </table>
        <paginator :paginator="meta" v-on:pageclick="getAuditLogs"/>
    </div>
</template>

<script>
import Datepicker from 'vue3-datepicker'
import { ref } from 'vue'
import SubNav from './SubNav.vue';
import JetNavLink from '@/Jetstream/NavLink'
import Paginator from "./Paginator.vue";
import exportFromJSON from "export-from-json";

export default {
    components: {
        SubNav,
        JetNavLink,
        Paginator,
        Datepicker,
    },
    data() {
        return {
            data: [],
            links: {},
            meta: {},
            searchText: '',
            dateUpperLimit: new Date(),
            dateLowerLimit: new Date(Date.parse('2020-01-30')),
            fromPicked: null,
            toPicked: new Date(),
            queryString: '',
        }
    },
    methods: {
        getAuditLogs(queryString) {
            if (queryString) {
                this.queryString = queryString;
                axios.get('/api/audit-logs'+this.queryString)
                    .then((res) => {
                        this.data = res.data.data;
                        this.links = res.data.links;
                        this.meta = res.data.meta;
                    })
            } else {
                axios.get('/api/audit-logs')
                    .then((res) => {
                        this.data = res.data.data;
                        this.links = res.data.links;
                        this.meta = res.data.meta;
                    })
            }
        },
        filterDate() {
            let start = Date.parse(this.fromPicked);
            let end = Date.parse(this.toPicked);

            if (start && end) {
                this.getAuditLogs('?startDate='+start+'&endDate='+end);
            } else if (start) {
                this.getAuditLogs('?startDate='+start);
            } else if (end) {
                this.getAuditLogs('?endDate='+end);
            } else {
                alert("Date error");
                console.error("Date error");
            }
        },
        downloadCsv() {
            // unpaginated data
            let start = Date.parse(this.fromPicked);
            let end = Date.parse(this.toPicked);
            console.log("start: "+start+" | end: "+end);

            if (start && end) {
                console.log("startend");
                window.axios.get('/api/audit-logs?csv=true&startDate='+start+'&endDate='+end)
                    .then((res) => {
                        this.processCsv(res.data.data);
                    })
            } else if (start) {
                console.log("start");
                window.axios.get('/api/audit-logs?csv=true&startDate='+start)
                    .then((res) => {
                        this.processCsv(res.data.data);
                    })
            } else if (end) {
                console.log("end");
                axios.get('/api/audit-logs?csv=true&endDate='+end)
                    .then((res) => {
                        this.processCsv(res.data.data);
                    })
            } else {
                console.log("else");
                window.axios.get('/api/audit-logs?csv=true')
                    .then((res) => {
                        this.processCsv(res.data.data);
                    })
            }

        },
        processCsv(exportData) {
            const currentDate = new Date().toJSON();
            const fileName = "audit-logs_"+currentDate;
            const exportType = exportFromJSON.types.csv;

            let data = [];
            exportData.forEach((row) => {
                var name = row.user.first_name+" "+row.user.last_name;
                var country = row.user.country ? row.user.country : "null";

                data.push({ 'S/N': row.id, User: name, Event: row.event, 'Event Details': row.event_details, Country: country, Role: row.user.role, 'Activity Date': row.date });
            });

            if (data) exportFromJSON({ data, fileName, exportType });
        },
    },
    mounted() {
        this.getAuditLogs();
    },
};
</script>

<style scoped>
    .date-container {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;
    }

    #myInput {
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" fill="%23666" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>'); /* CSS-only search icon */
        background-position: 10px 12px; /* Position the search icon */
        background-repeat: no-repeat; /* Do not repeat the icon image */
        width: 100%; /* Full-width */
        font-size: 16px; /* Increase font-size */
        padding: 12px 20px 12px 40px; /* Add some padding */
        border: 1px solid #ddd; /* Add a grey border */
        margin-bottom: 12px; /* Add some space below the input */
    }

    #myTable {
        border-collapse: collapse; /* Collapse borders */
        width: 100%; /* Full-width */
        border: 1px solid #ddd; /* Add a grey border */
        font-size: 18px; /* Increase font-size */
    }

    #myTable th, #myTable td {
        text-align: left; /* Left-align text */
        padding: 12px; /* Add padding */
    }

    #myTable tr {
        /* Add a bottom border to all table rows */
        border-bottom: 1px solid #ddd;
    }

    #myTable tr.header, #myTable tr:hover {
        /* Add a grey background color to the table header and on hover */
        background-color: #f1f1f1;
    }
</style>